import React from 'react';
import DocumentEditor from './DocumentEditor';

const CanvasPage = () => {
  return (
    <div className="canvas-page">
      <DocumentEditor />
    </div>
  );
};

export default CanvasPage;